import axios from 'axios';
import { ISeedCategory, ISeedIcon } from 'src/infrastructure/interfaces';

export default class SeedIconService {

    static toggleSeedIconPublish(seedIcon: ISeedIcon) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/seedIcon/${seedIcon.id}`,
                {
                    id: seedIcon.id,
                    src: seedIcon.src,
                    name: seedIcon.name,
                    categoryId: seedIcon.category.id,
                    published: seedIcon.published
                })
                .then((res) => {
                    resolve(res.data);
                })
                .catch(error => reject(error));
        });
    }

    static editSeedIcon(seedIcon: ISeedIcon, formData?: FormData) {
        if (formData) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/seedIconImage',
                        formData,
                        { headers: {'Content-Type': 'multipart/form-data' }})
                    .then((res) => {
                        const src = res.data.file;
                        axios.put(`/seedIcon/${seedIcon.id}`,
                        {
                            id: seedIcon.id,
                            src: src,
                            name: seedIcon.name,
                            categoryId: seedIcon.category.id,
                            published: seedIcon.published
                        })
                        .then((res) => {
                            resolve(res.data);
                        })
                        .catch(error => reject(error));
                    })
            });
        } else {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/seedIcon/${seedIcon.id}`,
                    {
                        id: seedIcon.id,
                        src: seedIcon.src,
                        name: seedIcon.name,
                        categoryId: seedIcon.category.id,
                        published: seedIcon.published
                    })
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch(error => reject(error));
            });
        }
    }

    static createSeedIcon(iconName: string, category: ISeedCategory, formData: FormData) {
        return new Promise((resolve, reject) => {
            axios
                .post('/seedIconImage',
                    formData,
                    { headers: {'Content-Type': 'multipart/form-data' }})
                .then((res) => {
                    const src = res.data.file;
                    axios
                        .post('/seedIcon', { name: iconName, categoryId: category.id, src })
                        .then((res) => {
                            resolve(res.data);
                        })
                })
                .catch(error => reject(error));
        });
    }

    static deleteSeedIcon(seedIcon: ISeedIcon) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/seedIcon/${seedIcon.id}`)
                .then((res) => {
                    resolve(res.data);
                })
                .catch(error => reject(error));
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/SeedIconService.ts